function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useQuery } from '@apollo/client';
import { getClientEnvironmentDetails } from '@sm/utils';
import experimentsQuery from './Experiments.graphql';
function useExperiment(_ref) {
  var name = _ref.name,
    treatmentNames = _ref.treatmentNames;
  var _getClientEnvironment = getClientEnvironmentDetails(),
    isBrowser = _getClientEnvironment.isBrowser;
  var pageReferer = isBrowser ? document.referrer : '/';
  var pageUrl = isBrowser ? window.location.href : '/';
  // convert the name to an array without whitespace if it is not already
  var experimentNames = Array.isArray(name) ? name : name.split(' ').map(function (el) {
    return el.trim();
  });
  var _useQuery = useQuery(experimentsQuery, {
      fetchPolicy: 'no-cache',
      variables: {
        pageReferer: pageReferer,
        pageUrl: pageUrl,
        experimentNames: experimentNames
      }
    }),
    data = _useQuery.data,
    loading = _useQuery.loading;
  var experiments = data === null || data === void 0 ? void 0 : data.experiments;
  var baseObj = {
    treatments: {},
    loading: loading
  };

  // if loading, we want to fire the loading component provide by the user
  if (loading) return baseObj;

  // If the service fails, or the experiments are undefined, we will want to show the control.
  if ((experiments === null || experiments === void 0 ? void 0 : experiments.length) === 0 || !experiments) return baseObj;

  // @todo: support multiple experiment names - nice to have for the future
  // easy way to just return the object if it exists
  var expObj = experiments.find(function (exp) {
    return name === exp.name;
  });
  if (!expObj) return baseObj;

  // possibility: read experiments that exist in state?
  var notAssigned = {};
  treatmentNames.forEach(function (treatment) {
    if (treatment !== expObj.treatment.name) {
      notAssigned[treatment] = {};
    }
  });

  // @todo: look at changing this data structure to something different in next iteration
  var reduced = Object.keys(expObj).reduce(function (acc) {
    // eslint-disable-next-line no-param-reassign
    acc = {
      treatments: _defineProperty({}, expObj.treatment.name, {
        treatmentName: expObj.treatment.name,
        treatmentId: expObj.treatment.id,
        experimentId: expObj.id,
        experimentName: expObj.name,
        assignmentType: expObj.assignmentType
      }),
      name: expObj.name,
      loading: loading
    };
    return acc;
  }, {
    loading: loading,
    treatments: {}
  });
  Object.assign(reduced.treatments, notAssigned);
  // @ts-ignore
  return reduced;
}
export { useExperiment };
//# sourceMappingURL=index.js.map